import {
  Box,
  FormControl,
  Grid,
  MenuItem,
  Select,
  SelectChangeEvent
} from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LanguageIcon } from './StyledComponents/Index';

export const languageCode = {
  ENGLISH: 'en',
  TAMIL: 'ta '
};

const lan = [
  { key: 'en', label: 'English' },
  { key: 'ta', label: 'தமிழ்' }
];

type Props = {};

const LanguageSelector = (props: Props) => {
  const { i18n } = useTranslation();

  const [selectedLanguage, setSelectedLanguage] = useState<{
    key: string;
    label: string;
  }>(
    localStorage.getItem('selectedLanguage') === null
      ? lan[0]
      : {
          key: localStorage.getItem('selectedLanguage'),
          label: lan.find(
            (item) => item.key === localStorage.getItem('selectedLanguage')
          ).label
        }
  );

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('selectedLanguage', lng);
  };

  const handleChange = (event: SelectChangeEvent, value: any) => {
    changeLanguage(event.target.value);
    setSelectedLanguage({
      key: event.target.value as string,
      label: value.props.children
    });
  };

  return (
    <>
      <Box sx={{ minWidth: 130 }}>
        <Grid container columnSpacing="30px">
          <Grid item md={3} xs={1} margin="auto">
            <LanguageIcon />
          </Grid>
          <Grid item md={9}>
            <FormControl fullWidth>
              <Select
                value={selectedLanguage.key}
                name={selectedLanguage.label}
                onChange={handleChange}
                fullWidth
                sx={{
                  height: '50px'
                }}
              >
                {lan.map((option) => {
                  return (
                    <MenuItem key={option.key} value={option.key}>
                      {option.label}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default LanguageSelector;
